import { useNavigate } from "react-router-dom";
import Cards from "../components/Cards";
import Card from "../components/Card";

export default function PageSettings() {


    const navigate = useNavigate();

    return (
        <div className="page page-settings">
            <Cards>
                <Card title="Delivery" description="Update delivery settings" onClick={() => navigate(`Delivery${window.location.search}`)} />
                {false ? <Card title="Themes" description="Install widgets" onClick={() => navigate(`Themes${window.location.search}`)} /> : null}
                <Card title="Widget" description="Update widgets settings" onClick={() => navigate(`Widget${window.location.search}`)} />
            </Cards>
        </div>
    );
}